/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Row, Col, Form, Button } from "react-bootstrap";

import { useUnsecurePost } from "../components/fetchHook";

import getPCPUrl from "../components/pcpUrl";




export default function UserRegistration() {
  const navigate = useNavigate();
  const { postData, response, isLoading, error } = useUnsecurePost();

  const [validated, setValidated] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [betaKey, setBetaKey] = useState("");


  useEffect(() => {
    if (response === null) {
      return;
    }

    navigate("/app/registered");

  }, [response]);



  function onUserChanged(event) {
    event.preventDefault();
    setUsername(event.target.value);
  }

  function onPasswordChanged(event) {
    event.preventDefault();
    setPassword(event.target.value);
  }

  function onFirstNameChanged(event) {
    event.preventDefault();
    setFirstName(event.target.value);
  }

  function onLastNameChanged(event) {
    event.preventDefault();
    setLastName(event.target.value);
  }

  function onBetaKeyChanged(event) {
    event.preventDefault();
    setBetaKey(event.target.value);
  }


  const onSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    if (isLoading === true) {
      return;
    }

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      return;
    }

    let url = getPCPUrl() + "registerUser";


    let body = {
      "email": username,
      "password": password,
      "first": firstName,
      "last": lastName,

      "betaCode": betaKey // TODO maybe rename one of these
    }

    await postData(url, JSON.stringify(body));
  }


  function buttonLabel(isTrying) {
    if (isTrying) {
      return <span>Registering ...<i className="fas fa-spinner fa-spin"></i></span>
    }

    return <span>Submit</span>
  }


  let error_style = {
    background: "#ffcccc",
    textAlign: "center",

    marginTop: "10px"
  }

  let hr_style = {
    textAlign: "center",

    marginBottom: "10px"
  }


  return (
    <Row>
      <Col lg={{ span: 6, offset: 3 }}>
        <h2 style={hr_style}>Registration</h2>

        <Form noValidate validated={validated} onSubmit={onSubmit}>

          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="name@example.com" required value={username} onChange={onUserChanged} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="pass">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" required value={password} onChange={onPasswordChanged} />
          </Form.Group>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="first">
              <Form.Label>First name</Form.Label>
              <Form.Control type="text" value={firstName} onChange={onFirstNameChanged} />
            </Form.Group>

            <Form.Group as={Col} controlId="last">
              <Form.Label>Last name</Form.Label>
              <Form.Control type="text" value={lastName} onChange={onLastNameChanged} />
            </Form.Group>
          </Row>

          <Form.Group className="mb-3" controlId="beta">
            <Form.Label>Beta key</Form.Label>
            <Form.Control type="text" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" required value={betaKey} onChange={onBetaKeyChanged} />
          </Form.Group>

          <div className="d-grid ">
            <Button variant="primary" type="submit" >{buttonLabel(isLoading)}</Button>
          </div>

          {error.length > 0 ? <div style={error_style}><p>{error}</p></div> : null}

        </Form>

      </Col>

    </Row>
  );
};

